import { getInstanceField } from './useGetInstanceField'

type SlideDirection =
  | 'vertically-up'
  | 'vertically-down'
  | 'horisontally-left'
  | 'horisontally-right'

type Transition =
  | 'fade'
  | 'rotate-scale'
  | 'portal-leaderboard'
  | `slide-${SlideDirection}`

export type ToastOptions = {
  title?: string
  text: string
  theme?: 'success' | 'error' | 'warning'
  duration?: number
  transitionType?: Transition
  isSelfClosing?: boolean
}
const defaultToastOptions: ToastOptions = {
  title: '',
  text: '',
  theme: 'success',
  duration: 3000,
  isSelfClosing: true,
  transitionType: 'slide-vertically-down',
}

const getDefaultToastOptions = (type?: 'error' | 'success' | 'warning') => {
  const duration = type === 'error' ? 5000 : 3000

  return { ...defaultToastOptions, duration }
}

const joinToastOptions = (toastOptions: ToastOptions | undefined) => {
  const presetToastOptions = getDefaultToastOptions(toastOptions?.theme)
  const { title, text, theme, duration, transitionType, isSelfClosing } = {
    ...defaultToastOptions,
    ...toastOptions,
  }

  const durationNumber = Math.max(Number(duration), presetToastOptions.duration)

  return {
    primary: { title, text },
    settings: {
      theme,
      duration: durationNumber,
      transitionType,
      isSelfClosing,
    },
  }
}

export const useToast = () => {
  const toast = getInstanceField('$toast')

  const doToast = (toastOptions: ToastOptions | undefined) => {
    const { primary, settings } = joinToastOptions(toastOptions)
    toast(primary, settings)
  }
  return { doToast }
}
